module.exports = __webpack_public_path__ + "static/media/kampania_500_01_B.2af3965e.png";